export const faqItems = [
  {
    id: 1,
    question: 'What is this form for?',
    answer:
      'To report issues, ask questions, or share suggestions about the TDI-Connect Portal and its features.',
  },
  {
    id: 2,
    question: 'When should I use it?',
    answer:
      "Use it when something isn't working as expected, you need clarification, or you want to propose an improvement.",
  },
  {
    id: 3,
    question: 'What should I not use it for?',
    answer:
      'Not for security incidents, general IT problems (VPN/laptop/email), or product-specific support handled by other teams.',
  },
  {
    id: 4,
    question: 'Who receives my submission?',
    answer:
      'The TDI-Connect team (engineering, product, and portal maintainers) review and route all incoming feedback.',
  },
  {
    id: 5,
    question: 'What info should I include?',
    answer:
      'Describe the issue clearly, include steps to reproduce, relevant screenshots, and your project or product instance.',
  },
  {
    id: 6,
    question: 'Will my feedback be used?',
    answer: 'Yes—every submission is reviewed and helps guide improvements to the portal.',
  },
];
